import { useState, useEffect } from 'react';
import { Button, Row, Col, Form } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import { addUnitMeasure } from '../../services/Other/GeneralQueries';

function AddUnitsModal({ show, handleClose, handleReload }) {
  const [unitName, setUnitName] = useState("");
  const [abbreviation, setAbbreviation] = useState("");

  const handleChangeUnitName = (e) => {
    const { value } = e.target;
    setUnitName(value);
  }

  const handleChangeAbbreviation = (e) => {
    const { value } = e.target;
    setAbbreviation(value);
  }

  const handleAddUnitMeasure = () => {
    let pendingInputs = [];

    if (!unitName) {
      pendingInputs.push("Nombre de la unidad de medida")
    }

    if (!abbreviation) {
      pendingInputs.push("Abreviación de la unidad de medida")
    }

    if (pendingInputs.length == 0) {

      addUnitMeasure(unitName, abbreviation).then(unitResult => {
        toast.success('unidad de medida creada correctamente');
        handleClose();
        handleReload();
      });
    }
    else {
      toast.warning(`Lo sentimos, debes completar los siguientes campos: ${pendingInputs.join(', ')}`)
    }
  }

  useEffect(() => {
    if (show) {
      setUnitName("");
      setAbbreviation("");
    }
  }, [show]);

  return (
    <Modal size="sm" show={show} onHide={handleClose} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>Agregar unidad de medida</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col xl={12} className=' p-2'  >
            <Form.Label>Nombre:</Form.Label>
            <Form.Group controlId="">
              <Form.Control
                type="text"
                name="name"
                placeholder='Nombre de la unidad de medida'
                value={unitName}
                onChange={handleChangeUnitName}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col xl={12} className=' p-2'  >
            <Form.Label>Abreviación:</Form.Label>
            <Form.Group controlId="">
              <Form.Control
                type="text"
                name="abbreviation"
                placeholder='Ejemplo: pz, gr, ml, lt.'
                value={abbreviation}
                onChange={handleChangeAbbreviation}
              />
            </Form.Group>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="success" onClick={handleAddUnitMeasure}>
          Guardar
        </Button>
        <Button variant="secondary" onClick={handleClose}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default AddUnitsModal;